export const sort = [
  { label: "Lok.", name: "id", sortable: false },
  { label: "Ilość pozycji", name: "warehouse_positions", sortable: false },
];
